// extracted by mini-css-extract-plugin
module.exports = {"chip":"chip_chip__33REn","label":"chip_label__19V7r","remove":"chip_remove__WhZ7X","glyph":"chip_glyph__kD63k"};